<template>
  <v-stepper-content step="0" class="pb-0">
    <v-alert
      v-if="timeLeft == 0 && $store.getters['game/timer']"
      class="animated bounceIn"
      type="error"
    >{{$t('general.timerMessage')}}</v-alert>
    <v-sheet
      class="text-center mb-1 card-title"
      color="primary"
      elevation="1"
      dark
    >{{$t('steps.bufferSetup')}}</v-sheet>
    <v-card class="pa-4" outlined :class="{'test-mode' : $store.getters['game/test']}">
      <v-row align="center">
        <v-col cols="6" align="center" class="animated bounceInLeft delay-1s">
          <v-row>
            <v-col cols="6" align="center" align-self="center">
                <v-switch
                  class="mt-0 mb-2"
                  hide-details
                  :label="$t('dd.applyAutoCmj')"
                  v-model="bufferBaseOnAutoCmj"
                ></v-switch>
              <v-text-field
                :label="$t('dd.calculatedCMJ')"
                filled
                type="number"
                v-model.number="localParams.cmjAuto"
                readonly
              ></v-text-field>
              <v-text-field
                :label="$t('dd.AverageStockLevelTarget')"
                filled
                type="number"
                v-model.number="AverageStockLevelTarget"
                readonly
              ></v-text-field>
            </v-col>
            <v-col cols="6" align="center">
              <v-form ref="bufferForm" @submit="false">
                <v-text-field
                  :label="$t('dd.cmj')"
                  outlined
                  type="number"
                  @input="bufferCalc"
                  v-model.number="localParams.cmj"
                  :rules="[v => !!v || $t('general.required')]"
                ></v-text-field>
                <v-text-field
                  :label="$t('dd.leadTime')"
                  outlined
                  type="number"
                  @input="bufferCalc"
                  v-model.number="localParams.leadTime"
                  :rules="[v => !!v || $t('general.required')]"
                ></v-text-field>
                <v-text-field
                  :label="$t('dd.delayFactor')"
                  outlined
                  type="number"
                  @input="bufferCalc"
                  v-model.number="localParams.delayFactor"
                  :rules="[v => !!v || $t('general.required')]"
                ></v-text-field>
                <v-text-field
                  :label="$t('dd.variabilityFactor')"
                  outlined
                  type="number"
                  @input="bufferCalc"
                  v-model.number="localParams.variabilityFactor"
                  :rules="[v => !!v || $t('general.required')]"
                ></v-text-field>
              </v-form>
            </v-col>
          </v-row>
        </v-col>
        <v-col cols="6" align="center" class="animated bounceInRight delay-1s">
          <buffer
            v-if="step == 0"
            chartId="chartBufferSetup"
            :renderBuffer="renderBuffer"
            :red="red"
            :yellow="yellow"
            :green="green"
            :flowEquation="0"
            :withFlowEquation="false"
          ></buffer>
        </v-col>
      </v-row>
    </v-card>
    <v-row>
      <v-col cols="12" align="center">
        <v-btn
          class="animated bounceIn delay-2s"
          color="primary"
          :loading="$store.state.company.loading"
          :disabled="$store.state.company.loading"
          @click="validate"
        >{{$t('general.ok')}}</v-btn>
      </v-col>
    </v-row>
  </v-stepper-content>
</template>

<script>
import Buffer from '@/components/Buffer'
export default {
  name: "BufferSetup",
  components: {
    Buffer
  },
  props: {
    step: Number,
    timeLeft: Number
  },
  data: () => ({
    AverageStockLevelTarget: 0,
    renderBuffer: false,
    red: 0,
    yellow: 0,
    green: 0,
    bufferBaseOnAutoCmj: false,
    localParams: {
      cmjAuto: 0,
      cmj: 0,
      delayFactor: 0,
      variabilityFactor: 0,
      leadTime: 0
    }
  }),
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.localParams = Object.assign({}, this.$store.getters['company/data'].dd.params)
      this.bufferBaseOnAutoCmj = this.$store.getters['company/data'].dd.bufferBaseOnAutoCmj
      if (this.bufferBaseOnAutoCmj) {
        this.localParams.cmj = this.localParams.cmjAuto
      }
      this.renderBuffer = false
      setTimeout(() => this.bufferCalc(), 0)
    },
    validate() {
      if (this.$refs.bufferForm.validate()) {
        this.$store.dispatch('company/setBuffer', {
          red: this.red,
          yellow: this.yellow,
          green: this.green,
          ddParams: this.localParams,
          bufferBaseOnAutoCmj: this.bufferBaseOnAutoCmj
        })
      }
    },
    async bufferCalc() {
      this.green = Math.ceil(
        this.localParams.cmj *
          this.localParams.leadTime *
          (this.localParams.delayFactor / 100)
      );
      this.yellow = Math.ceil(this.localParams.cmj * this.localParams.leadTime);
      this.red = Math.ceil(
        this.green + this.green * (this.localParams.variabilityFactor / 100)
      );
      this.AverageStockLevelTarget = this.red + this.green / 2;
      this.renderBuffer = false
      setTimeout(() => this.renderBuffer = true, 200)
    }
  },
  computed: {},
  watch: {
    step(val) {
      if (val == 0) {
        this.init()
      }
    },
    bufferBaseOnAutoCmj (val) {
      if (val) {
        this.localParams.cmj = this.localParams.cmjAuto
        this.bufferCalc()
      }
    }
  }
};
</script>